import React, { useMemo } from "react";

import { useTypedSelector } from "../../../store/models/root.interface";
import StatisticBox from "../../../common/components/StatisticBox";

const AttendeesSidebar = () => {

  const statistics = useTypedSelector((state) => state.attendees.statistics);

  const data = useMemo(() => ({
    id: 0,
    title: "Total Attendees",
    description: "",
    value: statistics?.attendance?.total,
    results: [
      {
        id: 0,
        title: "Unique",
        value: statistics?.attendance?.unique,
      },
      {
        id: 1,
        title: "Repeat",
        value: statistics?.attendance?.repeat,
      },
    ],
  }), [statistics]);

  return (
    <div className="m-3">
      <StatisticBox {...data} />
    </div>
  );
};

export default AttendeesSidebar;
